import React from 'react'
import style from './Footer.module.css'

const Busbooking = () => {
  return (
    <div className={style.boxmargin}>
      <h3>Online Bus Booking in India</h3>
      <p>
        India has a large network of roads, and buses go pretty much everywhere.
        Bus travel is economical, and services are frequent and fast. From curvy
        mountains, rocky terrains to small villages, buses take you everywhere
        in India and are an affordable mode of transport. There are a variety of
        buses available and booking bus tickets online has become effortless.
        There are different kinds of buses in India such as state-owned, luxury
        buses, deluxe or super deluxe. There are also the Volvo AC and non AC
        buses, Mercedes, Express and other private buses and they hardly ever
        need to be booked in advance. Although, pre- booking of bus tickets is
        advisable. ixigo provides online bus booking services throughout the
        length of the country with amazing deals on bus ticket prices. If you’re
        looking for the cheapest bus ticket prices, head straight to our online
        bus ticket booking platform as soon as possible. With 1000+ buses
        between 200 cities across the country, finding the perfect deal for your
        travel plans will never be a hassle. The buses run by the state
        government are usually more reliable. In case of a breakdown, another
        bus is sent to drop the passengers. Although, government-owned buses get
        sold out very fast. If you have already planned your trip, it is
        suggested to make the online bus booking in advance to get the bus and
        seat of your choice. On ixigo, you can make bus tickets booking of
        different routes across the country.
      </p>
    </div>
  )
}

export default Busbooking
